export type useMapDrawingProps = {
    map: google.maps.Map | null;
    enabled: boolean;
};

export enum DrawMode {
    Polygon = 'polygon',
    Freehand = 'freehand',
    Select = 'select',
}
